import { AnalyticsBrowser } from '@segment/analytics-next'

import { getUtmsFromQuery } from '../query-params'
import { DispatchEventProperties } from './types/types'

const segment = AnalyticsBrowser.load({
  writeKey: process.env.NEXT_PUBLIC_APP_SEGMENT_WRITE_KEY || ''
})
export const dispatchIdentifyEvent = async (
  userId?: string,
  userProps?: Record<string, string>
) => {
  await segment.identify(userId, userProps)
}

export const dispatchEvent = async ({
  eventName,
  ...rest
}: DispatchEventProperties) => {
  await segment.track(eventName, {
    ...rest,
    ...getGlobalProps()
  })
}

const getGlobalProps = () => {
  const utms = getUtms()
  const platform = getPlatform()
  const pagePath = window !== undefined ? window.location.pathname : null

  return {
    platform,
    pagePath,
    ...utms
  }
}

const getUtms = () => {
  const queryString = window !== undefined ? window.location.search : ''
  const searchParams = new URLSearchParams(queryString)
  const query = Object.fromEntries(searchParams.entries())

  return query ? getUtmsFromQuery(query) : {}
}

const getPlatform = () => {
  if (typeof window === 'undefined') return ''
  if (window.innerWidth < 768) return 'web_mobile'
  if (window.innerWidth >= 768 && window.innerWidth < 1366) return 'web_tablet'
  return 'web_desktop'
}
